import(/* webpackMode: "eager" */ "/home/runner/work/play/play/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/src/app/_components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/home/runner/work/play/play/src/components/Dashboard/Dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/home/runner/work/play/play/src/components/ui-kit/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/ContentBox/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/GameHeader/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/GamesGrid/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/GameSpecs/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/hooks/screenSizeHooks.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/hooks/useSpyScrollPercentage.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/hooks/useTimeCountdown.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/Loader/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/MediaCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromotionTile"] */ "/home/runner/work/play/play/src/components/ui-kit/PromotionTile/PromotionTile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderOnceInView"] */ "/home/runner/work/play/play/src/components/ui-kit/RenderOnceInView/RenderOnceInView.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/components/ui-kit/SectionDivider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectionProvider"] */ "/home/runner/work/play/play/src/hooks/connection.tsx");
